		<!-- public nav -->
        <nav class="navbar sticky-top shadow-sm navbar-expand-xl navbar-dark bg-primary p-4">
			<div class="container-fluid">
				<a class="navbar-brand" href="#">
					<img src="../../assets/images/logo/logo-white.svg" alt="Logo">
				</a>
				<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
					<div class="">
						<div class="d-flex align-items-center justify-content-end m-100 lgBlock mb-2">
							<form class="d-flex me-4 align-items-center m-100 navForm">
								<input class="form-control navSearch" type="text" placeholder="Search our site or find a member" aria-label="Search">
								<a class="text-blue navSearchIcon" href="#" style="margin-left: -38px;"><i class="fa-regular fa-magnifying-glass"></i></a>
							</form>
							<a *ngIf="!userIsLoggedIn" class="ms-xl-2 btn btn-secondary btn-sm rounded enterBtn m-100" (click)="openLoginModal()">Login | Join</a>
							<div *ngIf="userIsLoggedIn" class="dropdown">
								<button class="btn btn-secondary px-3 dropdown-toggle" type="button" id="userDrop" data-bs-toggle="dropdown" aria-expanded="false">
								  <span class="userIcon me-2"><i class="fa-regular fa-user"></i></span> <span class="me-2">{{myUser.fullName}}</span>
								</button>
								<ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDrop">
								  <li><a class="dropdown-item" [routerLink]="['/public/my-account']" href="javascript:void(0);"><i class="fa-light fa-pencil fa-fw"></i> Edit Profile</a></li>
								  <li><a class="dropdown-item" (click)="logout()" href="javascript:void(0);"><i class="fa-light fa-power-off fa-fw"></i> Logout</a></li>
								</ul>
							  </div>
						</div>
						<ul class="navbar-nav justify-content-end">
							<!-- menu -->
							<li class="nav-item dropdown">
								<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownEvents" role="button" data-bs-toggle="dropdown" aria-expanded="false">
									Member Information
								</a>
								<ul class="dropdown-menu dropdown-menu-lg-end" aria-labelledby="navbarDropdownEvents">
									<li><a class="dropdown-item" [routerLink]="['/public/member-directory']">Member Directory</a></li>
									<li><a class="dropdown-item" [routerLink]="['/public/member-news']">Member News</a></li>
									<li *ngIf="userIsLoggedIn && memberLevel != 'HealthAlliance'"><a class="dropdown-item" [routerLink]="['/public/member-discounts']">Discounts & Perks</a></li>
									<li *ngIf="userIsLoggedIn && memberLevel != 'HealthAlliance'"><a class="dropdown-item" [routerLink]="['/public/resources']">Member Resources</a></li>
									<li><a class="dropdown-item" [routerLink]="['/public/public-payments']">Submit Payment</a></li>
								</ul>
							</li>
							<!-- menu -->
							<!-- <li class="nav-item dropdown">
								<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMembership" role="button" data-bs-toggle="dropdown" aria-expanded="false">
									Participate
								</a>
								<ul class="dropdown-menu dropdown-menu-lg-end" aria-labelledby="navbarDropdownMembership">
									<li><a class="dropdown-item" href="submit-member-news.html">Submit Member News</a></li>
									<li><a class="dropdown-item" href="submit-discount.html">Submit Discount</a></li>
									<li><a class="dropdown-item" href="submit-ad.html">Submit an Ad</a></li>
								</ul>
							</li> -->
							<!-- menu -->
							<li class="nav-item dropdown">
								<a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdownIP" role="button" data-bs-toggle="dropdown" aria-expanded="false">
									Indy Chamber
								</a>
								<ul class="dropdown-menu dropdown-menu-lg-end" aria-labelledby="navbarDropdownIP">
									<li *ngIf="canAccessMemberContent || memberLevel == 'HealthAlliance'"><a class="dropdown-item" href="javascript:void(0)" (click)="navToAdminPortal()">Management Portal</a></li>
									<li><a class="dropdown-item" href="https://indychamber.com/">Back to Indy Chamber</a></li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</nav>